<template>

  <div>
    <Swipe :autoplay="3000">
      <SwipeItem v-for="(item, index) of adList" :key="index">
        <img class="swipeImage" :src="type === 1 ? item.picUrl : item.otherPicUrl" alt="" @click="jumpTo(item.url)"/>
      </SwipeItem>
    </Swipe>
    <div class="form_wp">

      <Form class="form" @submit="onSubmit">
        <Field
            v-model="account"
            name="account"
            label="卡号"
            placeholder="请输入卡号"
            :rules="[{ required: true }]"
            center
        >
        </Field>
        <Field
            v-model="password"
            name="password"
            label="卡密"
            placeholder="请输入卡密"
            :rules="[{ required: true }]"
            center
        >
        </Field>
        <Field
            v-model="captcha"
            name="captcha"
            label="验证码"
            placeholder="请输入验证码"
            :rules="[{ required: true }]"
            center
        >
          <template #button>
            <img :src="captchaUrl" class="insertImg" @click="getCaptcha">
          </template>
        </Field>
        <div style="margin: 16px;">
          <Button round block type="info" native-type="submit">立即登录</Button>
        </div>
      </Form>

      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Form, Field, Swipe, SwipeItem, Button, Dialog, Toast } from 'vant'
import { v4 as uuidv4 } from 'uuid';
import Footer from "../components/Footer";
import store from "../store";
import config from "../config";
export default {
  components: {
    Footer,
    Form,
    Field,
    Swipe,
    SwipeItem,
    Button
  },
  props: {
    onSuccess: Function,
    type: Number
  },
  data() {
    return {
      account: '',
      password: '',
      captcha: '',
      captchaUrl: '',
      uuid: '',
      adList: []
    }
  },
  methods: {
    onSubmit (values) {
      axios.post(`${config.publicPath}/exchange-api/api/card/login`, {
        ...values,
        uuid: this.uuid
      }).then(res => {
        const { code, data, msg } = res.data
        if (code === 0) {
          store.setItem('token', data.token)
          store.setItem('cardId', data.id)
          store.setItem('planId', data.planId)
          store.setItem('status', data.status)
          Toast.success('登录成功');
          if (this.$props.onSuccess) {
            this.$props.onSuccess()
          }
        } else {
          Toast({
            message: msg,
            position: 'bottom',
          });
          this.getCaptcha()
        }
      })
    },
    getCaptcha () {
      const uuid = uuidv4()
      this.uuid = uuid
      axios.get(
          `${config.publicPath}/exchange-api/api/card/captcha?uuid=${uuid}`,
          {
            headers:{
              "Accept": "application/octet-stream"
            },
            responseType: "blob"
          }
      ).then(res => {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.captchaUrl = e.target.result
        };
        reader.readAsDataURL(res.data);
      })
    },
    getAd () {
      axios.get(`${config.publicPath}/exchange-api/api/ad/page`).then(res => {
        if (res.data.code === 0) {
          this.adList = res.data.data.list
        } else {
          this.getCaptcha()
        }
      })
    },
    jumpTo (url) {
      window.location.href = url
    },
    getWelcome () {
      axios.get(`${config.publicPath}/exchange-api/exchange/welcome/page`).then(res => {
        if (res.data.code === 0 && res.data.data.list.length > 0) {
          Dialog.confirm({
            title: '温馨提示',
            message: res.data.data.list[0].content,
            theme: 'round-button',
            confirmButtonText: '确定',
            confirmButtonColor: '#1989fa',
            showCancelButton: false
          })
        }
      })
    }
  },

  mounted() {
    this.getCaptcha()
    this.getAd()
    if (!store.state.token) {
      this.getWelcome()
    }
  }
}
</script>
<style scoped lang="less">
.swipeImage {
  width: 100%;
  object-fit: contain;
}

.form_wp {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.form {
  margin-top: 30px;
  padding: 0 10px;
}
.insertImg {
  height: 30px;
}

.van-cell span {
  width: 50%;
  display: inline-flex;
  justify-content: stretch;
}

</style>